import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 18.25A8.25 8.25 0 1 1 18.25 10v2a2.25 2.25 0 0 1-4.5 0m.5-2a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
